import { isMendsVisionEnabled } from '../mendsAi/services/MendsVisionService';
import { fetchOnboardingStatus } from '../mendsAi/services/onboarding';
import { homePath } from './homePath';

/** Quanto o login espera o servidor dizer se a conta precisa do assistente antes de seguir sem a resposta. */
export const LANDING_STATUS_TIMEOUT_MS = 4000;

/**
 * Destino logo após entrar: o assistente de primeiro acesso (/comecar) quando a conta não tem WhatsApp conectado ou
 * quando uma conexão ligada ainda não tem base montada; senão, a tela inicial de sempre. Quem decide é o servidor:
 * <c>isFirstAccess</c> só fica valendo se a consulta falhar ou demorar mais que {@link LANDING_STATUS_TIMEOUT_MS}
 * (contas antigas mantêm a flag ligada até trocar a senha). Nunca prende o login.
 */
export async function landingPath(
  isFirstAccess?: boolean,
  visionEnabled: boolean = isMendsVisionEnabled(),
  timeoutMs: number = LANDING_STATUS_TIMEOUT_MS,
): Promise<string> {
  if (!visionEnabled) return homePath(false);
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    // Timeout do axios e um limite próprio: rede pendurada (sem resposta nem erro) também libera o login.
    const status = await Promise.race([
      fetchOnboardingStatus(timeoutMs),
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new Error('onboarding_status_timeout')), timeoutMs);
      }),
    ]);
    return status.needsOnboarding ? '/comecar' : homePath(true);
  } catch {
    return isFirstAccess ? '/comecar' : homePath(true);
  } finally {
    if (timer !== undefined) clearTimeout(timer);
  }
}
